import { useLocation } from 'react-router-dom';
import React, { useEffect, useRef } from 'react';
import Header from '../../Header';
import Footer from '../../Footer';
import RetirementHeroSection from './RetirementHeroSection';
import WhyChooseRetirementSection from './WhyChooseRetirementSection';
import FAQ from './FAQ';
import RetirementTypesSection from './RetirementTypesSection';



const RetirementPlanning = () => {
  const location = useLocation();
  const typesRef = useRef(null);
  
  useEffect(() => {
    // Check if there's state with focusSection
    if (location.state && location.state.focusSection) {
      const sectionId = location.state.focusSection;
      const element = document.getElementById(sectionId);
      
      if (element && location.state.skipScrolling) {
        // Use scrollIntoView with a behavior of 'auto' to jump directly without animation
        element.scrollIntoView({ behavior: 'auto' });
        
        // Store reference to prevent re-scrolling on subsequent renders
        typesRef.current = element;
      }
    }
  }, [location]);
    return (
      <div className="min-h-screen flex flex-col">
        <Header/>
        <main className="flex-grow">
            <RetirementHeroSection/>
            <WhyChooseRetirementSection/>
            <RetirementTypesSection/>
            <FAQ/>
        </main>
        <Footer/>
      </div>
    );
  };
  
  export default RetirementPlanning;